import {dashboardApi} from 'sources/api';
import urlWithParams from 'utils/urlWithParams';

const dateFormat = 'YYYY-MM-DD';
export default {
  getBestRepScores(managerId, startDate, endDate, teamId) {
    return dashboardApi.getJson(
      urlWithParams(`/team_rank/${managerId}/rep_activity`, {
        start_date: startDate.format(dateFormat),
        end_date: endDate.format(dateFormat),
        teamId: teamId,
      })
    );
  },

  getFeedbackScores(managerId, startDate, endDate, teamId) {
    return dashboardApi.getJson(
      urlWithParams(`/team_rank/${managerId}/feedback`, {
        start_date: startDate.format(dateFormat),
        end_date: endDate.format(dateFormat),
        teamId: teamId,
      })
    );
  },

  getEngagementScores(managerId, startDate, endDate, teamId) {
    return dashboardApi.getJson(
      urlWithParams(`/team_rank/${managerId}/engagement`, {
        start_date: startDate.format(dateFormat),
        end_date: endDate.format(dateFormat),
        teamId: teamId,
      })
    );
  },

  getScoringScores(managerId, startDate, endDate, teamId) {
    return dashboardApi.getJson(
      urlWithParams(`/team_rank/${managerId}/score`, {
        start_date: startDate.format(dateFormat),
        end_date: endDate.format(dateFormat),
        teamId: teamId,
      })
    );
  },

  getCoachingReceivedTeamScores(managerId, startDate, endDate, teamId) {
    return dashboardApi.getJson(
      urlWithParams(`/team_rank/${managerId}/coaching_received`, {
        start_date: startDate.format(dateFormat),
        end_date: endDate.format(dateFormat),
        teamId: teamId,
      })
    );
  },
};
